import { SVGProps } from 'react'

export const MasterCardBW = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="65"
      height="46"
      viewBox="0 0 65 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.1093 32.5677C30.9439 34.4752 28.1351 35.6268 25.0658 35.6268C18.2173 35.6268 12.6655 29.8935 12.6655 22.8212C12.6655 15.7489 18.2173 10.0156 25.0658 10.0156C28.1351 10.0156 30.9439 11.1672 33.1093 13.0747C35.2746 11.1672 38.0835 10.0156 41.1527 10.0156C48.0012 10.0156 53.553 15.7489 53.553 22.8212C53.553 29.8935 48.0012 35.6268 41.1527 35.6268C38.0835 35.6268 35.2746 34.4752 33.1093 32.5677Z"
        fill="#323232"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.1094 32.5677C35.7756 30.2189 37.4662 26.7239 37.4662 22.8212C37.4662 18.9185 35.7756 15.4235 33.1094 13.0747C35.2747 11.1672 38.0836 10.0156 41.1528 10.0156C48.0013 10.0156 53.5531 15.7489 53.5531 22.8212C53.5531 29.8935 48.0013 35.6268 41.1528 35.6268C38.0836 35.6268 35.2747 34.4752 33.1094 32.5677Z"
        fill="#A7A7A7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.1093 32.5672C35.7755 30.2184 37.4661 26.7234 37.4661 22.8207C37.4661 18.918 35.7755 15.423 33.1093 13.0742C30.4431 15.423 28.7524 18.918 28.7524 22.8207C28.7524 26.7234 30.4431 30.2184 33.1093 32.5672Z"
        fill="#7A7A7A"
      />
    </svg>
  )
}
